module.exports = __webpack_public_path__ + "assets/b60.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b60.png
// module id = 650
// module chunks = 0